import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FobChargesModalService {

  private selectedFobChargeSubject = new BehaviorSubject<any>(null);
  public selectedFobCharge$ = this.selectedFobChargeSubject.asObservable();

  constructor() { }

  setSelectedFobCharge(fobCharge: any): void {
    this.selectedFobChargeSubject.next(fobCharge);
  }

  getSelectedFobCharge(): any | null {
    return this.selectedFobChargeSubject.value;
  }

  clearSelectedFobCharge(): void {
    this.selectedFobChargeSubject.next(null);
  }
}

